// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f9a0df6","239":"f66bcba2","453":"ce10df93","732":"05d39a1a"}[chunkId] + ".chunk.js";
};